import getRequiredParameters from "./getRequiredParameters";
import isParameterEmpty from "../../isParameterEmpty";

const validateParameters = (app, nocall, parameters) => {
  const requiredParameters = getRequiredParameters(app, nocall);

  requiredParameters.forEach((requiredParameter) => {
    if (isParameterEmpty(parameters[requiredParameter])) {
      throw Error(
        `Parameter '${requiredParameter}' is required to make the call to the api`
      );
    }
  });
};

export default validateParameters;
